import React, { useContext } from 'react';

const FirebaseContext = React.createContext(null);
export const withFirebase = Component => props => (
    <FirebaseContext.Consumer>
      {firebase => <Component {...props} firebase={firebase} />}
    </FirebaseContext.Consumer>
  );
  export const useFirebase = () => {
    const firebaseContext = useContext(FirebaseContext);
    if (firebaseContext === undefined) {
      throw new Error(
        "useFirebase must be used within a FirebaseContext.Provider"
      );
    }
    return firebaseContext;
  };

  

export default FirebaseContext;